import moment from "moment";

export default function findDates({ from, days }) {
  const start = moment(from).startOf().isoWeekday(1).toDate();
  const dates = [];
  for (let i = 0; i < days; i++) {
    dates.push(moment(start).add(i, "days").toDate());
  }
  return dates;
}
